import { render, staticRenderFns } from "./optionItems-editor.vue?vue&type=template&id=e9ccbb00&scoped=true&"
import script from "./optionItems-editor.vue?vue&type=script&lang=js&"
export * from "./optionItems-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ccbb00",
  null
  
)

export default component.exports